import AdminEntity from "../../components/admin/AdminEntity";

export function AdminAttractionsPage() {
  return (
    <AdminEntity config={{
      eyebrow: "Local guide", title: "Attractions",
      testidPrefix: "admin-attractions", singular: "attraction",
      listEndpoint: "/attractions", keyField: "slug",
      columns: [
        { key: "name", label: "Name" },
        { key: "category", label: "Category" },
        { key: "drive_time_min", label: "Drive (min)" },
        { key: "drive_time_miles", label: "Drive (mi)" },
      ],
      updateEndpoint: (a) => `/admin/attractions/${a.slug}`,
      fields: [
        { name: "name", label: "Name", required: true },
        { name: "category", label: "Category" },
        { name: "summary", label: "Summary", type: "textarea", rows: 3 },
        { name: "detail", label: "Detail", type: "textarea", rows: 5 },
        { name: "drive_time_min", label: "Drive time (min)", type: "number" },
        { name: "drive_time_miles", label: "Distance (mi)", type: "number" },
        { name: "route", label: "Route" },
        { name: "image", label: "Image path" },
        { name: "order", label: "Sort order", type: "number" },
      ],
    }} />
  );
}

export function AdminTownsPage() {
  return (
    <AdminEntity config={{
      eyebrow: "Local guide", title: "Nearby towns",
      testidPrefix: "admin-towns", singular: "town",
      listEndpoint: "/nearby-towns", keyField: "slug",
      columns: [
        { key: "name", label: "Town" },
        { key: "drive_time_min", label: "Drive (min)" },
        { key: "drive_time_miles", label: "Drive (mi)" },
        { key: "summary", label: "Summary" },
      ],
      updateEndpoint: (t) => `/admin/nearby-towns/${t.slug}`,
      fields: [
        { name: "name", label: "Town name", required: true },
        { name: "drive_time_min", label: "Drive time (min)", type: "number" },
        { name: "drive_time_miles", label: "Distance (mi)", type: "number" },
        { name: "summary", label: "Summary", type: "textarea", rows: 3 },
        { name: "order", label: "Sort order", type: "number" },
      ],
    }} />
  );
}

export function AdminRedirectsPage() {
  return (
    <AdminEntity config={{
      eyebrow: "SEO", title: "301 Redirects",
      testidPrefix: "admin-redirects", singular: "redirect", addLabel: "New redirect",
      listEndpoint: "/redirects", keyField: "id",
      columns: [
        { key: "from_path", label: "From" },
        { key: "to_path", label: "To" },
        { key: "status_code", label: "Status" },
      ],
      createEndpoint: "/redirects",
      deleteEndpoint: (r) => `/redirects/${r.id}`,
      fields: [
        { name: "from_path", label: "From path", required: true, help: "Legacy path e.g. /old-page/" },
        { name: "to_path", label: "To path", required: true, help: "New path e.g. /rooms" },
        { name: "status_code", label: "Status code", type: "number", defaultValue: 301 },
      ],
    }} />
  );
}

export function AdminEventsPage() {
  return (
    <AdminEntity config={{
      eyebrow: "Calendar", title: "Local events",
      testidPrefix: "admin-events", singular: "event", addLabel: "New event",
      listEndpoint: "/events", keyField: "slug",
      columns: [
        { key: "name", label: "Event" },
        { key: "month", label: "Month" },
        { key: "day_start", label: "Start" },
        { key: "day_end", label: "End" },
        { key: "recurring", label: "Recurring", render: (e) => e.recurring ? "Yes" : "No" },
      ],
      createEndpoint: "/admin/events",
      updateEndpoint: (e) => `/admin/events/${e.slug}`,
      deleteEndpoint: (e) => `/admin/events/${e.slug}`,
      fields: [
        { name: "slug", label: "Slug", required: true },
        { name: "name", label: "Event name", required: true },
        { name: "month", label: "Month (1–12)", type: "number", required: true },
        { name: "day_start", label: "Start day (1–31)", type: "number" },
        { name: "day_end", label: "End day (1–31)", type: "number" },
        { name: "description", label: "Description", type: "textarea", rows: 4, required: true },
        { name: "recurring", label: "Recurring", type: "boolean", defaultValue: true },
        { name: "order", label: "Sort order", type: "number" },
      ],
    }} />
  );
}
